import React from 'react';
import { Helmet } from 'react-helmet-async';
import useMediaQuery from '../hooks/useMediaQuery';
import DesktopHome from './DesktopHome';
import MobileHome from './MobileHome';

const Home = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <Helmet>
        <title>Real Estate in India - Buy, Sell, Rent Properties | Real Properties</title>
        <meta name="description" content="Discover the best real estate in India. Search and explore top residential and commercial properties, projects, and verified real estate sites across India." />
        <meta name="keywords" content="real estate, real estate in india, buy property, sell property, rent property, commercial real estate, open plots, residential projects, luxury homes, approved properties Andhra Pradesh Telangana, RERA approved plots villas flats AP, Wealth Associates real estate, buy property Andhra Pradesh Telangana, legally verified properties AP Telangana" />
        <link rel="canonical" href="https://www.realproperties.in/" />
      </Helmet>
      {isMobile ? <MobileHome /> : <DesktopHome />}
    </>
  );
};

export default Home;
